import { render, staticRenderFns } from "./inventory-gain.vue?vue&type=template&id=cf7706ee"
import script from "./inventory-gain.vue?vue&type=script&lang=js"
export * from "./inventory-gain.vue?vue&type=script&lang=js"
import style0 from "./inventory-gain.vue?vue&type=style&index=0&id=cf7706ee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports